import contract from '@/api/wholesale/sale-contract'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'
import { split } from 'lodash';

export const state = {
  ...baseState,
  products: [],
  customers: [],
  quotations: [],
  status: [],
  sc_status_id: [],
  exchangeRate: [],
  employees: [],
  has_create_si: undefined,
  dateRange: [moment().add(-1, 'months').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')],
  formViewData: []
}

export const getters = {
  // getProduct: state => ({ chosenProduct, search = '' } = {}) => {
  //   // if(chosenProduct !== undefined){
  //   //   return state.products.filter(p => 
  //   //     !_.includes(chosenProduct.map(el => el.product_id),p.product_id)
  //   //   )
  //   //   .filter(p => 
  //   //     search.split(' ').every((s) => p.product_name_en.toLowerCase().includes(s.toLowerCase()))  ||
  //   //     search.split(' ').every((s) => p.barcode.toLowerCase().includes(s.toLowerCase())) 
  //   //   )
  //   //   .slice(0, 100);
  //   // }
  //   // return state.products.slice(0, 100);
  // },
  getUom: state => productId => {
    if (productId && state.products.length) {
      let prod = state.products.find(p => p.product_id == productId)
      return prod.uom_category.unit_of_measures

    }
  },
  isDefaultUom: state => productId => {
    if (productId && state.products.length) {
      let product = state.products.find(p => p.product_id == productId)
      var uom = product.uom_category.unit_of_measures.find(u => u.is_default == true)
      return uom.uom_id
    }
    return null
  },
  // use when change uom in item lists
  getSalePrice: state => ({ product_id, uom_id = null }) => {
    if (product_id && state.products.length) {
      let pro = state.products.find(p => p.product_id == product_id)
      var uom = pro.uom_category.unit_of_measures.find(u => uom_id ? u.uom_id == uom_id : u.is_default == true)
      var salecode = pro.sale_code.find(
        s => s.uom_id == uom.uom_id
      )
      return salecode.product_price ? salecode.product_price.sale_price ? salecode.product_price.sale_price : 0 : 0
    }
    return 0
  },
  getCost: state => ({ product_id, uom_id = null }) => {
    if (product_id && state.products.length) {
      let pro = state.products.find(p => p.product_id == product_id)
      var uom = pro.uom_category.unit_of_measures.find(u => uom_id ? u.uom_id == uom_id : u.is_default == true)
      var salecode = pro.sale_code.find(
        s => s.uom_id == uom.uom_id
      )
      return salecode.product_price ? salecode.product_price.cost ? salecode.product_price.cost : 0 : 0
    }
    return 0
  },
  findProduct: state => productId => {
    if (!productId) {
      return {
        barcode: null,
        product_name_en: null
      }
    }
    return state.products.find(p => p.product_id == productId)
  },
}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_PRODUCT(state, data) {
    let checkExist = state.products.find(p => p.product_id == data.product_id)
    if (!checkExist) {
      state.products.push(data)
    }
  },
  SET_CUSTOMER(state, data) {
    state.customers = data
  },
  PUSH_NEW_CUSTOMER(state, data) {
    // if not exists
    let exist = state.formViewData.customer.find(c => c.customer_id == data.customer_id)
    if (!exist) {
      state.formViewData.customer.push(data)
    }
  },
  PUSH_NEW_BROKER(state, data) {
    // if not exists
    let exist = state.formViewData.broker.find(c => c.customer_id == data.customer_id)
    if (!exist) {
      state.formViewData.broker.push(data)
    }
  },
  PUSH_NEW_QUOTATION(state, data) {
    // if not exists
    let exist = state.quotations.find(c => c.quotation_no == data.quotation_no)
    if (!exist) {
      state.quotations.push(data)
    }
  },
  SET_QUOTATION(state, data) {
    state.quotations = data
  },
  SET_STATUS(state, data) {
    state.status = data
  },
  SET_STATUS_FILTER(state, data) {
    state.sc_status_id = data
  },
  SET_EXCHANGE_RATE(state, data) {
    state.exchangeRate = data
  },
  SET_HAS_CREATE_SI(state, data) {
    state.has_create_si = data
  },
  CLEAR_SETUP(state) {
    state.products = []
    state.customers = []
    state.quotations = []
    state.exchangeRate = []
  },
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewData = data;
    } else {
      split(index, ",").forEach(el => {
        state.formViewData[el] = data[el];
      });
    }
  },
  SET_EMPLOYEE(state, data) {
    state.employees = data
  },
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search,
          date_between: _.join(context.state.dateRange, ','),
          sc_status_id: _.join(context.state.sc_status_id, ','),
          has_create_si: context.state.has_create_si
        }
      },
      attrubutes
    )
    return contract.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return contract.store(data)
  },
  update(context, { id, data }) {
    return contract.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await contract.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
    return Promise.resolve()
  },
  destroy(context, { id, data }) {
    return contract.destroy(id, data)
  },
  previewPdf(context, id) {
    return contract.toPdf(id)
  },
  async getStatus(context) {
    let var_status = await contract.status()
    context.commit('SET_STATUS', var_status.data)
  },
  async getProduct(context, attributes = {}) {
    return await contract.product({ params: attributes })
  },
  async getCustomer(context, attributes = {}) {
    let var_customer = await contract.customer({ params: attributes })
    context.commit('SET_CUSTOMER', var_customer.data)
  },
  async getFormViewData(context, { params, index }) {
    let response = await contract.formModel({ params: params });
    context.commit("SET_VIEW_MODELS", {
      data: response.data,
      index: index
    });
    return Promise.resolve(response);
  },
  bankProfile(context) {
    return contract.bankProfile()
  },
  getBalance(context, payload) {
    return contract.getBalance(payload)
  },
  async getSale(context, search) {
    let var_employee = await contract.formModel({
      params: {
        fnName: 'sale',
        search_sale: search
      }
    })
    context.commit('SET_EMPLOYEE', var_employee.data['sale'])
  },
}
